/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import TimelineEvent from 'solis/logic/board/zone/timeline/event';


export default class ExpiryEvent extends TimelineEvent
{
  constructor (zone)
  {
    super(zone);

    this.user = null;
    this.value = null;

    this.influence = null;
  }


  findNextDate ()
  {
    for (const influence of this.zone.getInfluences().values())
    {
      if (this.setEarlierDate(influence.cass.destroyDate))
      {
        this.user = influence.getSourceUserID();
        this.value = influence.cass.value;

        this.influence = influence;
      }
    }
  }


  apply ()
  {
    super.apply();

    this.zone.getBoard().unloadInfluence(this.influence.cass);

    this.influence = null;
  }


  getLabel ()
  {
    return `${this.getUserName(this.user)} ${this.value} influence expires`;
  }


};
